import { render, staticRenderFns } from "./SMSCampaignListQuickCreateOrEdit.vue?vue&type=template&id=5bb66218&"
import script from "./SMSCampaignListQuickCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./SMSCampaignListQuickCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./SMSCampaignListQuickCreateOrEdit.vue?vue&type=style&index=0&id=5bb66218&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports